import { CreateSaleCatalogue } from './create-sale-catalogue';

export * from './create-sale-catalogue-props';

export default CreateSaleCatalogue;
